module.exports = __webpack_public_path__ + "static/media/SW.1b711008.png";